import { z } from "zod";
import { AGENT_CHAT_MAX_PLAN_STEPS } from "../board-agent-config";

export const boardPlanStepSchema = z.object({
	op: z.string().min(1).describe("Board mutation tool name"),
	input: z
		.record(z.string(), z.unknown())
		.default({})
		.describe(
			"Input for the op. For ids created earlier in this plan, use step refs " +
				"$0, $1, … (zero-based) instead of inventing shapeIds — e.g. " +
				'fromShapeId: "$0", toShapeId: "$1".',
		),
});

export const boardPlanInputSchema = z.object({
	reason: z
		.string()
		.optional()
		.describe("Short explanation of why this plan is needed"),
	steps: z
		.array(boardPlanStepSchema)
		.min(1)
		.max(AGENT_CHAT_MAX_PLAN_STEPS)
		.describe(
			"Ordered mutation steps. New content: put creates + arrows in the SAME " +
				"plan; wire arrows with $N refs. Adjustments: prefer alignShapes / " +
				"moveShape / updateGeoShape / updateDrawShape / distributeShapes on " +
				"existing ids — do not wipe and recreate. Do not call createArrow in " +
				"parallel with runBoardPlan.",
		),
	stopOnError: z
		.boolean()
		.optional()
		.describe("Stop on first failed step (default true)"),
});

export type BoardPlanInput = z.infer<typeof boardPlanInputSchema>;

export type BoardPlanStepResult = {
	op: string;
	ok: boolean;
	result?: unknown;
	error?: string;
	/** Input after $N step-ref resolution (when ok). */
	resolvedInput?: Record<string, unknown>;
};

export type BoardPlanResult = {
	applied: number;
	failedAt?: number;
	steps: BoardPlanStepResult[];
	touchedShapeIds: string[];
	reason?: string;
};
